/* HONEY MONEY · Inicio (P23, etapa 1b): paralaje del hero, entrada a la barbería con scroll, centrado de la foto en móvil y revelados (.hm-rv).
   Copia de la demo aprobada (template.html, P22). El resto de la tienda no usa revelados: las páginas cambian al instante. */
(() => {
if (window.__hmHome) return; window.__hmHome = true;
const $ = (s, r = document) => r.querySelector(s);
const hboxPx = () => parseFloat(getComputedStyle(document.body).getPropertyValue('--hbox')) || 0;
const boot = () => {
  /* revelados de la Home */
  const els = [...document.querySelectorAll('.hm-rv:not(.in)')];
  if (els.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), {threshold: .12, rootMargin: '0px 0px -5% 0px'});
    els.forEach(el => io.observe(el));
  } else els.forEach(el => el.classList.add('in'));
  const hero = $('#hm-hero'), pin = $('#hm-barber-pin'), sticky = $('.hm-barber__sticky');
  const hb = () => { const h = $('.hm-hbox'); return h ? h.getBoundingClientRect().height + 8 : hboxPx(); };
  let raf = 0;
  const tick = () => {
    raf = 0;
    if (hero) { const y = scrollY; if (y < innerHeight * 1.2) hero.style.setProperty('--sy', y); }
    if (pin && sticky && innerWidth > 860) {
      const r = pin.getBoundingClientRect(), span = r.height - (innerHeight - hb());
      const p = Math.min(1, Math.max(0, -r.top / span)), zoom = Math.min(1, p / .55);
      sticky.style.setProperty('--z', (1.35 - .35 * zoom).toFixed(4));
      sticky.style.setProperty('--br', (.3 + .7 * zoom).toFixed(3));
      sticky.style.setProperty('--io', Math.max(0, 1 - p / .3).toFixed(3));
      const show = Math.min(1, Math.max(0, (p - .5) / .15));
      sticky.style.setProperty('--ho', show.toFixed(3));
      sticky.style.setProperty('--hp', show > .5 ? 'auto' : 'none');
    }
  };
  const ask = () => { if (!raf) raf = requestAnimationFrame(tick); };
  if (hero || pin) { addEventListener('scroll', ask, {passive: true}); addEventListener('resize', ask); tick(); }
  /* móvil: la foto de la barbería empieza centrada en la silla del medio */
  const pan = $('#hm-pan');
  const centerPan = () => { if (pan && innerWidth <= 860) pan.scrollLeft = (pan.scrollWidth - pan.clientWidth) / 2; };
  addEventListener('load', centerPan); addEventListener('resize', centerPan); centerPan();
  /* /#barberia: baja hasta donde aparecen las sillas (al 70 % del recorrido), como el menú de la demo */
  const toBarber = () => {
    if (location.hash !== '#barberia' || !pin) return;
    const top = pin.getBoundingClientRect().top + scrollY;
    scrollTo({top: innerWidth > 860 ? top + (pin.offsetHeight - innerHeight + hb()) * .7 : top - 10, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
  };
  /* el menú marca Barbería mientras la dirección es /#barberia (y Inicio el resto del tiempo), como la demo */
  const links = [...document.querySelectorAll('.hm-nav a, .hm-mnav a')], home = links.filter(a => a.hasAttribute('aria-current')), bar = links.filter(a => new URL(a.href, location.href).hash === '#barberia'); // la que ya viene marcada del servidor es Inicio
  const mark = () => { if (!bar.length) return; const on = location.hash === '#barberia'; bar.forEach(a => on ? a.setAttribute('aria-current', 'page') : a.removeAttribute('aria-current')); home.forEach(a => on ? a.removeAttribute('aria-current') : a.setAttribute('aria-current', 'page')); };
  addEventListener('hashchange', () => { toBarber(); mark(); }); mark(); if (location.hash === '#barberia') setTimeout(toBarber, 250);
};
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
